module.exports = __webpack_public_path__ + "static/media/indexMarcaPonto.c5b256fc.jpg";